export default __webpack_public_path__ + "static/OpenSansLight-0b2419de2d9961109a56328fc4e611c9.svg";